const prod = "https://api.destinotolima.com/api/";
const test = "";
const locale = 'En';

export default{
    prod,
    test,
    locale
}